var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout"}},[_c('top-nav'),_c('div',{staticClass:"main"},[_c('router-view')],1),_c('bottom-info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }